import { format } from 'date-fns'
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'
import type { ReactNode } from 'react'

export const TimeTicks: React.FC<{
  ticks: number[]
  position(moment: number): number
}> = ({ ticks, position }) => (
  <div className="relative h-3 text-[10px] tabular-nums text-stone-400">
    {ticks.map(tick => (
      <span
        key={tick}
        className="absolute -translate-x-1/2 first:translate-x-0 last:-translate-x-full"
        style={{ left: `${position(tick) * 100}%` }}
      >
        {format(tick, 'HH:mm')}
      </span>
    ))}
  </div>
)

export const StepRow: React.FC<{
  previousLabel: string
  nextLabel: string
  disabled: boolean
  onStep(direction: 1 | -1): void
  children: ReactNode
}> = ({ previousLabel, nextLabel, disabled, onStep, children }) => (
  <div className="flex items-start gap-2 pt-1">
    <button
      type="button"
      aria-label={previousLabel}
      className="rounded-md p-1 text-stone-500 hover:bg-stone-100 hover:text-stone-900 disabled:opacity-30"
      disabled={disabled}
      onClick={() => onStep(-1)}
    >
      <ChevronLeftIcon className="h-4 w-4" />
    </button>
    <div className="line-clamp-2 h-9 flex-1 overflow-hidden pt-0.5 text-xs leading-4 text-stone-600">
      {children}
    </div>
    <button
      type="button"
      aria-label={nextLabel}
      className="rounded-md p-1 text-stone-500 hover:bg-stone-100 hover:text-stone-900 disabled:opacity-30"
      disabled={disabled}
      onClick={() => onStep(1)}
    >
      <ChevronRightIcon className="h-4 w-4" />
    </button>
  </div>
)

export const STRIP_CLASS =
  'relative h-12 cursor-pointer touch-pan-y select-none rounded-lg bg-stone-100 outline-none focus-visible:ring-2 focus-visible:ring-stone-400 md:h-9'
